import React, { useEffect, useState } from "react";
import classes from "./LandingPage.module.css";
import { motion } from "framer-motion";
import LinedSection from "../component/LinedSection";
import { FaArrowRight, FaStar, FaWhatsapp, FaGamepad, FaTrophy, FaBolt } from "react-icons/fa6";
import { fetchGamesApi } from "../http/http";
import { useNavigate } from "react-router-dom";
import AllGamesModal from "../component/AllGamesModal";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

/* ── Framer variants ── */
const fadeUp = {
    hidden: { opacity: 0, y: 32 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.55, ease: [0.4, 0, 0.2, 1], delay: i * 0.1 },
    }),
};

const scaleIn = {
    hidden: { opacity: 0, scale: 0.88 },
    show: (i = 0) => ({
        opacity: 1,
        scale: 1,
        transition: { duration: 0.5, ease: [0.4, 0, 0.2, 1], delay: i * 0.12 },
    }),
};

const LandingPage = () => {

    const [allGames, setAllGames] = useState([]);
    const [modal, setModal] = useState(false);
    const [popularGames, setPopularGames] = useState([]);
    const [loading, setLoading] = useState(true);

    const selectedLanguageId = Number(
        useSelector((state) => state?.persisted?.languageSlice?.language ?? 1)
    );

    const { t } = useTranslation();
    const navigate = useNavigate();

    const pickRandomK = (arr, k = 20) => {
        const n = Array.isArray(arr) ? arr.length : 0;
        if (n <= k) return arr ? [...arr] : [];
        const idx = new Set();
        while (idx.size < k) idx.add(Math.floor(Math.random() * n));
        return Array.from(idx, (i) => arr[i]);
    };

    const fetchGames = async (language) => {
        try {
            setLoading(true);
            const response = await fetchGamesApi(language);
            console.log(response, 'response--');
            setAllGames(response?.data?.games);

            setPopularGames([
                {
                    id: 0,
                    game_banner: "https://content.rashigames.com/games/200%20HTML%20Games/121%20Games/Poisonous%20Planets/Images/Poisonous%20Planets.png",
                    game_name: language == 1 ? "Poisonous Planets" : language == 2 ? "Planètes toxiques" : "Venenoso Planetas"
                },
                {
                    id: 1,
                    game_banner: "https://content.rashigames.com/games/200%20HTML%20Games/121%20Games/Pixel%20Jet%20Fighter/Thumbnails/Pixel%20Jet%20Fighter.png",
                    game_name: language == 1 ? "Pixel Jet Fighter" : language == 2 ? "Chasseur à réaction pixel" : "Pixel Jato Lutador"
                },
                {
                    id: 2,
                    game_banner: "https://content.rashigames.com/games/200%20HTML%20Games/121%20Games/Nutmeg%20Football/Thumbnails/Nutmeg%20Football.png",
                    game_name: language == 1 ? "Nutmeg Football" : language == 2 ? "Petit pont football" : "Noz-Moscada Futebol"
                },
                {
                    id: "3",
                    game_banner: "https://content.rashigames.com/games/200%20HTML%20Games/121%20Games/Speedy%20Boats/Thumbnails/Speedy%20Boats.jpg",
                    game_name: language == 1 ? "Speedy Boats" : language == 2 ? "Bateaux rapides" : "Rápido Barcos"
                }
            ]);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error, 'error--');
        }
    };

    console.log(popularGames, 'pg');

    useEffect(() => {
        fetchGames(selectedLanguageId);
    }, [selectedLanguageId]);

    return (
        <main className={classes.main}>

            {/* ─── TOP HEADER ─── */}
            <motion.header
                className={classes.header}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
            >
                <div className={classes.topBar}>
                    <div className={classes.brand}>
                        <div className={classes.brand_container}>
                            <img src="/images/uv-gaming-logo3.png" alt="uv gaming" className={classes.uv_logo} />
                            <div className={classes.brandSub}>Powered by Moov</div>
                        </div>
                    </div>

                    <div className={classes.topActions}>
                        {/* <button className={classes.btnGhost} onClick={() => navigate("/login")}>{t("1")}</button> */}
                        <button className={classes.btnPrimary} onClick={() => navigate("/subscribe")}>{t("2")}</button>
                    </div>
                </div>
            </motion.header>

            <motion.div
                className={classes.container}
                initial={{
                    backgroundImage:
                        "radial-gradient(820% 320% at 50% 25%, rgba(17, 46, 90, 0.22), transparent), radial-gradient(circle at 20% 20%, rgba(255, 121, 0, 0.18), transparent 22%), linear-gradient(180deg, #05132a 0%, #02050f 100%)",
                }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(820% 320% at 50% 25%, rgba(17, 46, 90, 0.22), transparent), radial-gradient(circle at 20% 20%, rgba(255, 121, 0, 0.18), transparent 22%), linear-gradient(180deg, #05132a 0%, #02050f 100%)",
                        "radial-gradient(820% 320% at 50% 25%, rgba(32, 73, 138, 0.18), transparent), radial-gradient(circle at 18% 18%, rgba(255, 131, 0, 0.2), transparent 24%), linear-gradient(180deg, #041b35 0%, #02040f 100%)",
                        "radial-gradient(820% 320% at 50% 25%, rgba(18, 53, 108, 0.24), transparent), radial-gradient(circle at 22% 22%, rgba(255, 121, 0, 0.22), transparent 24%), linear-gradient(180deg, #071d43 0%, #020613 100%)",
                        "radial-gradient(820% 320% at 50% 25%, rgba(27, 58, 124, 0.2), transparent), radial-gradient(circle at 19% 20%, rgba(255, 121, 0, 0.2), transparent 22%), linear-gradient(180deg, #061e47 0%, #020613 100%)",
                    ],
                }}
                transition={{
                    duration: 8,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                }}
            >
                {/* Glow orbs */}
                <div className={classes.glowLayer} />

                {/* Neon swoosh lines */}
                <LinedSection />

                <section className={classes.shell}>

                    {/* ─── STATS BAR ─── */}
                    <section className={classes.hero_container}>
                        <motion.div
                            className={classes.statsBar}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.2, ease: [0.4, 0, 0.2, 1] }}
                        >
                            <div className={classes.statItem}>
                                <FaGamepad className={classes.statIcon} />
                                <span className={classes.statNum}>200+</span>
                                <span className={classes.statLabel}>{t("1") === "Login" ? "Games" : "Jeux"}</span>
                            </div>
                            <div className={classes.statDivider} />
                            <div className={classes.statItem}>
                                <FaTrophy className={classes.statIcon} />
                                <span className={classes.statNum}>50K+</span>
                                <span className={classes.statLabel}>{t("1") === "Login" ? "Players" : "Joueurs"}</span>
                            </div>
                            <div className={classes.statDivider} />
                            <div className={classes.statItem}>
                                <FaBolt className={classes.statIcon} />
                                <span className={classes.statNum}>24/7</span>
                                <span className={classes.statLabel}>{t("1") === "Login" ? "Access" : "Accès"}</span>
                            </div>
                        </motion.div>
                    </section>

                    {/* ─── HERO ─── */}
                    <section className={classes.hero_container}>

                        <div className={classes.red_swoosh_container}>
                            <img src="/images/red-swoosh.png" alt="red swoosh" className={classes.red_swoosh_img} />
                        </div>

                        <section className={classes.hero}>

                            <motion.div
                                className={classes.heroLeft}
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={0}
                            >
                                <h1 className={classes.heroTitle}>
                                    {t("3")} <br />
                                    <span>{t("4")}</span>
                                </h1>

                                <motion.div
                                    className={classes.pricePill}
                                    onClick={() => navigate("/subscribe")}
                                    whileHover={{ scale: 1.04 }}
                                    whileTap={{ scale: 0.97 }}
                                >
                                    {t("5")} <b>{t("6")}</b> {t("7")}
                                </motion.div>

                                <div className={classes.heroChips}>
                                    <motion.div className={classes.chip} variants={fadeUp} custom={2}>
                                        <img src="/images/android.png" alt="android" className={classes.android_icon} />
                                        {t("8")}
                                    </motion.div>
                                    <motion.div className={classes.chip} variants={fadeUp} custom={3}>
                                        <img src="/images/wallet2.png" alt="wallet" className={classes.android_icon} />
                                        {t("9")} <b>{t('10')}</b>{t("11")}
                                        <img src="/images/Logo_Orange_Money.png" alt="m-pesa" className={classes.mpesa_in_chip} />
                                    </motion.div>
                                </div>
                            </motion.div>

                            <motion.div
                                className={classes.heroRight}
                                initial={{ opacity: 0, x: 40, scale: 0.92 }}
                                animate={{ opacity: 1, x: 0, scale: 1 }}
                                transition={{ duration: 0.8, delay: 0.15, ease: [0.4, 0, 0.2, 1] }}
                            >
                                <img src="/images/ChatGPT Image Jun 11, 2026, 05_51_47 PM.png" alt="Hero" className={classes.heroImage} />
                            </motion.div>

                        </section>
                    </section>

                    {/* ─── PLANS + HOW ─── */}
                    <section className={classes.hero_container}>
                        <section className={classes.midGrid}>

                            <motion.div
                                className={classes.cardSection}
                                variants={scaleIn}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, amount: 0.2 }}
                                custom={0}
                            >
                                <div className={classes.cardSectionBg}></div>

                                <h4 className={classes.sectionTitle}>{t("12")}</h4>

                                <div className={classes.planGrid}>
                                    {/* Daily */}
                                    <motion.div
                                        className={classes.planCard}
                                        onClick={() => navigate("/subscribe")}
                                        whileHover={{ y: -6 }}
                                        transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    >
                                        <div className={classes.planName}>{t("13")}</div>
                                        <div className={classes.planPrice}>
                                            <span>50</span>CFA
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/game-controller.png" alt="game" className={classes.planIcon} />
                                            {t("14")}
                                        </div>
                                        <button className={classes.planBtn}>{t("2")}</button>
                                    </motion.div>

                                    {/* Weekly — popular */}
                                    <motion.div
                                        className={`${classes.planCard} ${classes.popular}`}
                                        onClick={() => navigate("/subscribe")}
                                        whileHover={{ y: -10 }}
                                        transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    >
                                        <div className={classes.badge}>{t("15")}</div>
                                        <div className={classes.planName}>{t("16")}</div>
                                        <div className={classes.planPrice}>
                                            <span>250</span>CFA
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/schedule.png" alt="game" className={classes.planIcon} />
                                            {t("17")}
                                        </div>
                                        <button className={classes.planBtn}>{t("2")}</button>
                                    </motion.div>

                                    {/* Monthly */}
                                    {/* <motion.div
                                        className={classes.planCard}
                                        onClick={() => navigate("/subscribe")}
                                        whileHover={{ y: -6 }}
                                        transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    >
                                        <div className={classes.planName}>{t("18")}</div>
                                        <div className={classes.planPrice}>
                                            <span>500</span>CFA
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/calendar.png" alt="game" className={classes.planIcon} />
                                            {t("19")}
                                        </div>
                                        <button className={classes.planBtn}>{t("2")}</button>
                                    </motion.div> */}
                                </div>

                            </motion.div>

                            {/* How it works */}
                            <motion.aside
                                className={classes.howCard}
                                variants={scaleIn}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, amount: 0.2 }}
                                custom={1}
                            >
                                <div className={classes.howTitle}>{t("20")}</div>

                                <div className={classes.steps}>
                                    {[
                                        { num: 1, text: t("21") },
                                        { num: 2, text: t("22") },
                                        { num: 3, text: t("23") },
                                    ].map((s, i) => (
                                        <motion.div
                                            key={s.num}
                                            className={classes.step}
                                            initial={{ opacity: 0, x: -16 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: i * 0.12, duration: 0.4, ease: "easeOut" }}
                                        >
                                            <div className={classes.stepNum}>{s.num}</div>
                                            <div className={classes.stepText}>{s.text}</div>
                                        </motion.div>
                                    ))}
                                </div>

                                <motion.button
                                    className={classes.activateBtn}
                                    onClick={() => navigate("/subscribe")}
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    {t("24")} <span className={classes.arrow}><FaArrowRight /></span>
                                </motion.button>
                            </motion.aside>
                        </section>
                    </section>

                    <section className={classes.shell}>

                        {/* ─── FEATURED GAMES ─── */}
                        <section className={classes.hero_container}>
                            <motion.section
                                className={classes.featuredWrap}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.15 }}
                                transition={{ duration: 0.55, ease: [0.4, 0, 0.2, 1] }}
                            >
                                <div className={classes.featuredHead}>
                                    <div className={classes.sectionTitleSmall}>{t("25")}</div>
                                    <button
                                        disabled={loading}
                                        className={classes.linkBtn}
                                        onClick={() => setModal(true)}
                                    >{t("26")}</button>
                                </div>

                                <div className={classes.gamesRow}>
                                    {loading
                                        ? Array.from({ length: 4 }).map((_, idx) => (
                                            <div className={classes.gameCard} key={idx}>
                                                <div className={classes.gameImage}></div>
                                                <div className={classes.gameLabel}></div>
                                            </div>
                                        ))
                                        : popularGames?.map((d, idx) => (
                                            <motion.div
                                                className={classes.gameCard}
                                                key={idx}
                                                initial={{ opacity: 0, scale: 0.9 }}
                                                whileInView={{ opacity: 1, scale: 1 }}
                                                viewport={{ once: true }}
                                                transition={{ delay: idx * 0.08, duration: 0.45 }}
                                                whileHover={{ y: -6 }}
                                            >
                                                <img src={d?.game_banner} alt={d?.game_name} className={classes.gameImage} />
                                                <div className={classes.gameLabel}>
                                                    <p className={classes.gameText}>{d?.game_name}</p>
                                                </div>
                                            </motion.div>
                                        ))}
                                </div>
                            </motion.section>
                        </section>

                        {/* ─── PAYMENT + APP ─── */}
                        <section className={classes.hero_container}>
                            <section className={classes.bottomGrid}>

                                <motion.div
                                    className={classes.paymentCard}
                                    initial={{ opacity: 0, y: 24 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.2 }}
                                    transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
                                >
                                    <div className={classes.cardTitle}>
                                        <span className={classes.iconDot} /> {t("27")}
                                    </div>

                                    <div className={classes.logoGrid}>
                                        <motion.div className={classes.paymentMethod} whileHover={{ scale: 1.03 }}>
                                            <img src="/images/moovafricablue.png" alt="orange" className={classes.paymentMethodLogo} />
                                        </motion.div>
                                        <motion.div className={classes.paymentMethod} whileHover={{ scale: 1.03 }}>
                                            <img src="/images/Logo_Orange_Money.png" alt="orange money" className={classes.paymentMethodLogo} />
                                        </motion.div>
                                    </div>

                                    <div className={classes.safeText}>{t("28")}</div>
                                </motion.div>

                                <motion.div
                                    className={classes.appCard}
                                    initial={{ opacity: 0, y: 24 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.2 }}
                                    transition={{ duration: 0.5, delay: 0.1, ease: [0.4, 0, 0.2, 1] }}
                                >
                                    <div className={classes.appLeft}>
                                        <div className={classes.cardTitle}>
                                            <span className={classes.iconDot} /> {t("29")}
                                        </div>

                                        <motion.button
                                            className={classes.downloadBtn}
                                            whileHover={{ scale: 1.03 }}
                                            whileTap={{ scale: 0.97 }}
                                        >
                                            {t("30")}
                                        </motion.button>

                                        <div className={classes.ratingRow}>
                                            <div className={classes.ratingValue}>4.8</div>
                                            <div className={classes.stars}>
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                            </div>
                                        </div>
                                    </div>

                                    <img src="/images/phone.png" alt="android" className={classes.phoneMock} />
                                </motion.div>

                            </section>
                        </section>

                        {/* ─── FOOT CHIPS ─── */}
                        <section className={classes.hero_container}>
                            <motion.footer
                                className={classes.footerChips}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
                            >
                                <motion.div className={classes.footChip} whileHover={{ y: -3 }}>
                                    <FaWhatsapp className={classes.whatsapp_icon} />
                                    <span className={classes.footChip_paragraph}>{t("31")}</span>
                                </motion.div>
                                <motion.div className={classes.footChip} whileHover={{ y: -3 }}>
                                    {t("32")}
                                </motion.div>
                            </motion.footer>
                        </section>

                    </section>

                </section>
            </motion.div>

            <AllGamesModal games={allGames} modal={modal} setModal={setModal} />
        </main>
    );
};

export default LandingPage;